module.exports = __webpack_public_path__ + "static/media/logo.d12784b9.png";